/**
 * SHOPKO — "COMPRAR AHORA" (Landing Master)
 * - Lee la variante activa (formulario nativo del tema si existe; si no, la del botón).
 * - Si esa variante YA está en el carrito, va directo a /checkout (evita duplicar unidades).
 * - Si no, agrega 1 unidad vía /cart/add.js y redirige a /checkout (checkout nativo Shopify).
 * - Si algo falla, envía el formulario nativo (/cart/add + return_to=/checkout).
 * - Sincroniza el precio mostrado en los botones cuando cambia la variante.
 * No toca pagos, Starken, tarifas de despacho ni píxeles: Shopify emite sus eventos estándar.
 */
(function () {
  'use strict';
  if (window.__shopkoBuyNow) return;
  window.__shopkoBuyNow = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function moneyCLP(cents) {
    try {
      return new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', maximumFractionDigits: 0 }).format(cents / 100);
    } catch (e) {
      return '$' + Math.round(cents / 100);
    }
  }

  function getVariantsJson() {
    var picker = document.querySelector('variant-selects');
    if (!picker) return null;
    var s = picker.querySelector('script[type="application/json"]');
    if (!s) return null;
    try { return JSON.parse(s.textContent); } catch (e) { return null; }
  }

  // Variante según las opciones marcadas en el selector del tema (talla/color),
  // para fichas sin formulario nativo de compra (Landing Master con variantes).
  function getPickerVariantId() {
    var picker = document.querySelector('variant-selects');
    var variants = getVariantsJson();
    if (!picker || !variants) return null;
    var selected = [];
    picker.querySelectorAll('.product-form__input').forEach(function (group) {
      var checked = group.querySelector('input[type="radio"]:checked');
      var select = group.querySelector('select');
      if (checked) selected.push(checked.value);
      else if (select) selected.push(select.value);
    });
    if (!selected.length) return null;
    for (var i = 0; i < variants.length; i++) {
      var opts = variants[i].options || [];
      var match = opts.length === selected.length;
      for (var j = 0; match && j < opts.length; j++) { if (opts[j] !== selected[j]) match = false; }
      if (match) return String(variants[i].id);
    }
    return null;
  }

  function getMainVariantId() {
    var f = document.querySelector('form[data-type="add-to-cart-form"]');
    if (f) {
      var i = f.querySelector('input[name="id"]');
      if (i && !i.disabled && i.value) return i.value;
    }
    return getPickerVariantId();
  }

  function resolveVariantId(form) {
    var mainId = getMainVariantId();
    if (mainId) return mainId;
    var own = form.querySelector('[data-sk-variant-input]');
    return own ? own.value : null;
  }

  function syncPrices() {
    var id = getMainVariantId();
    var variants = getVariantsJson();
    if (!id || !variants) return;
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(id)) {
        var v = variants[i];
        document.querySelectorAll('[data-sk-price]').forEach(function (el) { el.textContent = moneyCLP(v.price); });
        document.querySelectorAll('[data-sk-variant-input]').forEach(function (el) { el.value = v.id; });
        document.querySelectorAll('[data-sk-buy-btn]').forEach(function (b) { b.disabled = !v.available; });
        document.querySelectorAll('[data-sk-variant-title]').forEach(function (el) { el.textContent = v.title; });
        return;
      }
    }
  }

  function goCheckout() { window.location.href = root + 'checkout'; }

  function onSubmit(e) {
    var form = e.target.closest('[data-sk-buy-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[data-sk-buy-btn]');
    var err = form.querySelector('[data-sk-buy-error]');
    if (btn && (btn.disabled || btn.classList.contains('is-loading'))) return;
    var id = resolveVariantId(form);
    if (!id) { form.submit(); return; }
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }

    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { items: [] }; })
      .catch(function () { return { items: [] }; })
      .then(function (cart) {
        var inCart = (cart.items || []).some(function (it) { return String(it.variant_id) === String(id); });
        if (inCart) { goCheckout(); return; }
        return fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
        }).then(function (r) {
          if (!r.ok) {
            return r.json().then(function (d) { throw new Error((d && d.description) || 'add_failed'); });
          }
          goCheckout();
        });
      })
      .catch(function (ex) {
        if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
        if (err) {
          err.textContent = (ex && ex.message && ex.message !== 'add_failed') ? ex.message : 'No pudimos agregar el producto. Intenta nuevamente.';
          err.hidden = false;
        }
      });
  }

  document.addEventListener('submit', onSubmit, true);
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('variant-selects')) window.setTimeout(syncPrices, 150);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncPrices);
  else syncPrices();
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('[data-sk-buy-btn].is-loading').forEach(function (b) {
      b.classList.remove('is-loading'); b.removeAttribute('aria-busy');
    });
  });
})();